var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('MarketingKpiFilters',{attrs:{"default":_vm.filters},on:{"updateFilter":_vm.handleFilters}}),(!_vm.loading)?_c('MarketingKpiStats',{attrs:{"data":_vm.stats}}):_vm._e(),_c('loader',{attrs:{"isVisible":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }